import { render, staticRenderFns } from "./GvdViewer.vue?vue&type=template&id=392f31bc"
import script from "./GvdViewer.vue?vue&type=script&lang=ts"
export * from "./GvdViewer.vue?vue&type=script&lang=ts"
import style0 from "./GvdViewer.vue?vue&type=style&index=0&id=392f31bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports